import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { pathname, userInfoFromHash } from 'store/entities/router/selectors'
import { getIdentityPendingEmailQuery } from 'store/entities/identity/selectors'
import { isTranslationsLoadedForLoginPage } from 'store/entities/organizationSettings/selectors'
import GuestRouter from './GuestRouter'

const mapStateToProps = createStructuredSelector({
  pathname,
  pending: getIdentityPendingEmailQuery,
  userInfoFromHash,
  isTranslationsLoadedForLoginPage,
})

export default withRouter(connect(mapStateToProps)(GuestRouter))
